import { useState } from 'react';

export default function Comparison() {
  const [selectedPlans, setSelectedPlans] = useState<string[]>([]);

  const allPlans = [
    { id: '1', carrier: '中華電信', name: 'NT$ 599', price: 599, data: '每月24G傳輸量', features: '傳輸到量降速(最高下載速率12Mbps)', voice: '網內前5分鐘免費 | 網外30分鐘 | 市話40分鐘' },
    { id: '2', carrier: '中華電信', name: 'NT$ 799', price: 799, data: '每月36G傳輸量', features: '傳輸到量降速(最高下載速率21Mbps)', voice: '網內前10分鐘免費 | 網外45分鐘 | 市話60分鐘' },
    { id: '3', carrier: '中華電信', name: 'NT$ 999', price: 999, data: '每月60G傳輸量', features: '傳輸到量降速(最高下載速率50Mbps)', voice: '網內免費 | 網外60分鐘 | 市話75分鐘' },
    { id: '4', carrier: '中華電信', name: 'NT$ 1399', price: 1399, data: '傳輸量吃到飽 | 熱點分享50G', features: '不降速', voice: '網內免費 | 網外110分鐘 | 市話140分鐘' },
    { id: '5', carrier: '台灣大哥大', name: 'NT$ 599', price: 599, data: '每月24G傳輸量', features: '傳輸到量降速(最高下載速率12Mbps)', voice: '網內免費 | 網外60分鐘' },
    { id: '6', carrier: '台灣大哥大', name: 'NT$ 799', price: 799, data: '每月36G傳輸量', features: '傳輸到量降速(最高下載速率21Mbps)', voice: '網內免費 | 網外60分鐘' },
    { id: '7', carrier: '台灣大哥大', name: 'NT$ 999', price: 999, data: '每月60G傳輸量', features: '傳輸到量降速(最高下載速率50Mbps)', voice: '網內免費 | 網外90分鐘' },
    { id: '8', carrier: '台灣大哥大', name: 'NT$ 1399', price: 1399, data: '傳輸量吃到飽 | 熱點分享50G', features: '不降速', voice: '網內免費 | 網外220分鐘' },
    { id: '9', carrier: '遠傳電信', name: 'NT$ 599', price: 599, data: '每月24G傳輸量', features: '傳輸到量降速(最高下載速率12Mbps)', voice: '網內免費 | 網外60分鐘' },
    { id: '10', carrier: '遠傳電信', name: 'NT$ 799', price: 799, data: '每月36G傳輸量', features: '傳輸到量降速(最高下載速率21Mbps)', voice: '網內免費 | 網外60分鐘' },
    { id: '11', carrier: '遠傳電信', name: 'NT$ 999', price: 999, data: '每月60G傳輸量', features: '傳輸到量降速(最高下載速率50Mbps)', voice: '網內免費 | 網外90分鐘' },
    { id: '12', carrier: '遠傳電信', name: 'NT$ 1399', price: 1399, data: '傳輸量吃到飽 | 熱點分享50G', features: '不降速', voice: '網內免費 | 網外220分鐘' }
  ];

  const togglePlan = (planId: string) => {
    if (selectedPlans.includes(planId)) {
      setSelectedPlans(selectedPlans.filter(id => id !== planId));
    } else if (selectedPlans.length < 3) {
      setSelectedPlans([...selectedPlans, planId]);
    }
  };

  const selectedPlanDetails = allPlans.filter(plan => selectedPlans.includes(plan.id));

  return (
    <section id="comparison" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            方案比對工具
          </h2>
          <p className="text-lg text-gray-600">
            選擇最多 3 個方案進行比較，找出最適合您的選擇
          </p>
        </div>

        <div className="mb-12">
          <h3 className="text-xl font-semibold text-gray-900 mb-6">選擇要比較的方案</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {allPlans.map((plan) => (
              <button
                key={plan.id}
                onClick={() => togglePlan(plan.id)}
                disabled={!selectedPlans.includes(plan.id) && selectedPlans.length >= 3}
                className={`p-4 rounded-lg border-2 transition-all cursor-pointer whitespace-nowrap ${
                  selectedPlans.includes(plan.id)
                    ? 'border-teal-600 bg-teal-50'
                    : 'border-gray-200 hover:border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed'
                }`}
              >
                <div className="text-xs text-gray-600 mb-1">{plan.carrier}</div>
                <div className="font-semibold text-sm text-gray-900">{plan.name}</div>
                <div className="text-teal-600 font-bold mt-2">NT$ {plan.price}</div>
              </button>
            ))}
          </div>
        </div>

        {selectedPlanDetails.length > 0 && (
          <div className="bg-gray-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">比較結果</h3>
            
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b-2 border-gray-200">
                    <th className="text-left py-4 px-4 font-semibold text-gray-700">項目</th>
                    {selectedPlanDetails.map((plan) => (
                      <th key={plan.id} className="text-center py-4 px-4">
                        <div className="font-semibold text-gray-900">{plan.name}</div>
                        <div className="text-xs text-gray-600 mt-1">{plan.carrier}</div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-200">
                    <td className="py-4 px-4 font-medium text-gray-700">月租費</td>
                    {selectedPlanDetails.map((plan) => (
                      <td key={plan.id} className="text-center py-4 px-4">
                        <span className="text-2xl font-bold text-teal-600">NT$ {plan.price}</span>
                      </td>
                    ))}
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-4 px-4 font-medium text-gray-700">傳輸量</td>
                    {selectedPlanDetails.map((plan) => (
                      <td key={plan.id} className="text-center py-4 px-4 text-gray-900 text-sm">
                        {plan.data}
                      </td>
                    ))}
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-4 px-4 font-medium text-gray-700">網路速度</td>
                    {selectedPlanDetails.map((plan) => (
                      <td key={plan.id} className="text-center py-4 px-4 text-gray-900 text-sm">
                        {plan.features}
                      </td>
                    ))}
                  </tr>
                  <tr className="border-b border-gray-200">
                    <td className="py-4 px-4 font-medium text-gray-700">通話方案</td>
                    {selectedPlanDetails.map((plan) => (
                      <td key={plan.id} className="text-center py-4 px-4 text-gray-900 text-sm">
                        {plan.voice}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <td className="py-4 px-4"></td>
                    {selectedPlanDetails.map((plan) => (
                      <td key={plan.id} className="text-center py-4 px-4">
                        <button className="bg-teal-600 text-white px-6 py-2.5 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                          選擇此方案
                        </button>
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {selectedPlanDetails.length === 0 && (
          <div className="text-center py-16 bg-gray-50 rounded-2xl">
            <i className="ri-file-list-3-line text-6xl text-gray-300 mb-4"></i>
            <p className="text-gray-500">請選擇要比較的方案</p>
          </div>
        )}
      </div>
    </section>
  );
}
